import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/core/auth.service';
import { IdentityClaimService } from '../../../services/IdentityClaim-service.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter();
  public router: string  = "";
  constructor(public authservice: AuthService,public identityClaimService: IdentityClaimService,private routerService: Router) 
  {
    this.identityClaimService.getValue().subscribe((value)=>{      
      this.SetIdentityClaims(value);
    })
   }
  Name: string = '';
  ngOnInit(): void {
    this.routerService.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.router = event.url; 
    });
  }

  toggleSidebar() {
    this.toggleSideBarForMe.emit();
  }
  logout() {

    this.authservice.logout();
  }

  SetIdentityClaims(IdentityClaims:any){
    try {     
      let firstName: any = '';
      let lastName: any = '';
      for (const [key, value] of Object.entries(JSON.parse(IdentityClaims))) {
        if (key === "firstname") {
          firstName = value;
        }
        if (key === "lastname") {
          lastName = value;
        }
      }
      this.Name = firstName + ' ' + lastName;
    } catch { }
  }
}
